namespace TabAurous.Inventory {
    export interface ConvertToWIPRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        AutoPosting?: boolean;
        DepartmentId?: number;
        ProcessId?: number;
        Line_No?: number;
        BagNo?: string;
        SubBagNo?: number;
        TermsId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        Roundoff?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        AddressId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        FinancialYearId?: number;
        UserId?: number;
        ItemDetails?: ConvertToWIPItemsRow[];
        ProductItemImage?: string;
        PostingDate?: string;
        IsPosted?: boolean;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        Username?: string;
    }

    export namespace ConvertToWIPRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Inventory.ConvertToWIP';
        export const deletePermission = 'Inventory:ConvertToWIP:Delete';
        export const insertPermission = 'Inventory:ConvertToWIP:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:ConvertToWIP:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            AutoPosting = "AutoPosting",
            DepartmentId = "DepartmentId",
            ProcessId = "ProcessId",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SubBagNo = "SubBagNo",
            TermsId = "TermsId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            Roundoff = "Roundoff",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            AddressId = "AddressId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            FinancialYearId = "FinancialYearId",
            UserId = "UserId",
            ItemDetails = "ItemDetails",
            ProductItemImage = "ProductItemImage",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            Username = "Username"
        }
    }
}
